
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import NotFound from "./pages/NotFound";
import { store } from '@/store';
import { Provider } from "react-redux";
import Router from './routes/Router'
import { useOnline } from "@/hooks/useOnline"
import { NoInternet } from "./components/NoInternet";


const queryClient = new QueryClient();

const App = () => {
  // const dispatch = useAppDispatch()
  // const profileState = useAppSelector(state => state.profile)
  // const authState = useAppSelector(state => state.auth)
  let isOnline = useOnline()





  if (!isOnline) {
    return <NoInternet />
  }

  return (<Provider store={store}>

    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner
          position="top-right"
          duration={2000}

        />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  </Provider>

  )
};

export default App;
